<template>
  <div class="row PayMethod">
    <div class="col">
      <div class="Title">付款方式</div>
      <div class="payList">
        <input type="radio" class="form-check-input" value="現金" v-model="this.$parent.$data.payMethod" :disabled="orderHandler == 0">
        <span class="checkboxSpan" @click="changePayMethod(0)">現金</span>
        <br>
        <input type="radio" class="form-check-input" value="LINE Pay" v-model="this.$parent.$data.payMethod" :disabled="orderHandler == 0 || hasLINEPay == 0" v-if="hasLINEPay">
        <span class="checkboxSpan" @click="changePayMethod(1)"  v-if="hasLINEPay">LINE Pay</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PayMethod",
  props: {
    hasLINEPay: Boolean,
    orderHandler: Number
  },
  methods: {
    /* 選擇付款方式 */
    changePayMethod: function (payMethodIndex) {
      switch (payMethodIndex) {
        case 0:
          this.$parent.$data.payMethod = '現金'
          break
        case 1:
          if (this.$parent.$data.Shop.hasLINEPay == false) return false
          this.$parent.$data.payMethod = 'LINE Pay'
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.PayMethod {
  margin: auto auto 20px auto !important;
  .Title {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 900;
    color: #87CEFAAA;
    text-shadow: 1px 1px 0 #000000;
  }
  .payList {
    padding: 20px 20px 10px 20px;
    border-radius: 8px;
    background: #f8f8f8;
    .checkboxSpan {
      display: inline-block;
      margin: auto auto 10px 10px;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
</style>